var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.meta)?_c('Pagination',{attrs:{"meta":_vm.meta,"on-change-page":_vm.onChangePage}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }